import { render, staticRenderFns } from "./MemberAddressAdd.vue?vue&type=template&id=1dd0725c&"
import script from "./MemberAddressAdd.vue?vue&type=script&lang=js&"
export * from "./MemberAddressAdd.vue?vue&type=script&lang=js&"
import style0 from "./MemberAddressAdd.vue?vue&type=style&index=0&id=1dd0725c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports